/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Status_ShippedInputs */

const en_fulfillment_status_shipped = /** @type {(inputs: Fulfillment_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Fulfillment_Status_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_status_shipped = /** @type {((inputs?: Fulfillment_Status_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Status_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_status_shipped(inputs)
});